export const DEBOUNCE_TIMEOUT_UPDATE_AMOUNT = 1200
export const DEBOUNCE_CART_INFO = 500
